import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "property-form-column property-form-wide"
}
const _hoisted_2 = { class: "property-form-column" }
const _hoisted_3 = {
  key: 1,
  class: "property-form-column"
}
const _hoisted_4 = {
  key: 2,
  class: "property-form-column property-form-wide"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["property-form", {'property-form--sided': !!_ctx.$slots.side}])
  }, [
    (_ctx.$slots.top)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "top", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "main", {}, undefined, true)
    ]),
    (_ctx.$slots.side)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "side", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.bottom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "bottom", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}